import { render } from "./NZUChapterBDetail.vue?vue&type=template&id=35381f23"
import script from "./NZUChapterBDetail.vue?vue&type=script&lang=js"
export * from "./NZUChapterBDetail.vue?vue&type=script&lang=js"

import "./NZUChapterBDetail.vue?vue&type=style&index=0&id=35381f23&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__